// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d6d33cb","453":"8f63576c","455":"5549d028","977":"1588a6c8"}[chunkId] + ".chunk.js";
};